import { appConfig as $config } from '../../app.config';

import './style.scss';

export const ItemCardNotice = (function () {
  const $processTmr = [];
  const $loadingHtml = '<i class="far fa-hourglass-end"></i> Processing...';

  const loadingComponent = (box) => {
    if (!$('.loading-component', box).length) {
      box.prepend(
        `<div class="loading-component"><div class="wrap"><span class="loadPercent"><i class="far fa-hourglass-end"></i>Processing...</span></div></div>`
      );
    }
  };

  const alert = ({ id, type, text }) => {
    const box = $(`[data-itemid=${id}]`);
    if (!box.length) return;
    clearAll(id);
    const tmpl = require('./tmpl/alert.hbs');
    const content = tmpl({ type: type, text: text });
    if ($('#page').length) {
      // - Native App
      $(`.box`, box).append(content);
    } else {
      box.append(content);
    }
  };

  const success = ({ id, text }) => {
    alert({ id: id, type: 'success', text: text });
  };

  const error = ({ id, text }) => {
    alert({ id: id, type: 'danger', text: text });
  };

  const complete = (mess) => {
    const id = mess.ObjectId;
    const data = mess.AdditionalData;
    if (mess.isComplete) {
      if (data.Text) {
        alert({
          id: id,
          text: data.Text,
          type: mess.isSuccess ? 'success' : 'danger'
        });
      } else {
        clearAll(id);
      }
      return true;
    }
    return false;
  };

  const loader = ({ id, show = true }) => {
    const box = $(`[data-itemid=${id}]`);
    if (!box.length) return;
    clearAlert(box);
    if (!$('.loading-component', box).length) {
      $('.box', box).prepend(
        `<div class="loading-component"><div class="wrap"><span class="loadPercent"><i class="far fa-hourglass-end"></i>Processing...</span></div></div>`
      );
    }
    box.removeClass('processing').toggleClass('loading', show);
    $('.loadPercent', box).empty().html($loadingHtml);
  };

  const process = (mess) => {
    const id = mess.ObjectId;
    const box = $(`div[data-itemid="${id}"]`);

    if (!box.length) return;

    clearAlert(box);
    if ($processTmr[id]) {
      clearInterval($processTmr[id]);
    }

    if (complete(mess)) {
      return;
    }

    const data = mess.AdditionalData;

    loadingComponent(box);

    setProcessPercent(box, data);

    setProcessWaiting(id);
  };

  const setProcessPercent = (box, data) => {
    if (data.Percent > 0) {
      box.removeClass('loading').addClass('processing');
      $('.loadPercent', box).empty().text(`${data.Percent}%`);
    } else {
      box.removeClass('processing').addClass('loading');
      $('.loadPercent', box).empty().html($loadingHtml);
    }
  };

  const setProcessWaiting = (id) => {
    $processTmr[id] = setInterval(() => {
      error({ id: id, text: 'Ooops! Server timeout :(' });
    }, $config.notification.processWaitingTimer);
  };

  const clearAlert = (box) => {
    $('.alert', box).remove();
  };

  const clearLoader = (box) => {
    box.removeClass('loading').removeClass('processing');
    $('.loadPercent', box).empty().html($loadingHtml);
  };

  const clearAll = (id) => {
    const box = $(`[data-itemid=${id}]`);
    clearAlert(box);
    clearLoader(box);
  };

  return {
    loader,
    process,
    alert,
    success,
    error,
    clearAll
  };
})();
